var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12;
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCabin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 120,
    height: 120,
    viewBox: "0 0 120 120",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M72.0001 93H66.0001V69H54.0001V93H48.0001V63H72.0001V93Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M88.5001 66C82.7101 66 78.0001 61.29 78.0001 55.5C78.0001 49.71 82.7101 45 88.5001 45C94.2901 45 99.0001 49.71 99.0001 55.5C99.0001 61.29 94.2901 66 88.5001 66ZM88.5001 51C86.0176 51 84.0001 53.0175 84.0001 55.5C84.0001 57.9825 86.0176 60 88.5001 60C90.9826 60 93.0001 57.9825 93.0001 55.5C93.0001 53.0175 90.9826 51 88.5001 51Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M88.5001 81C82.7101 81 78.0001 76.29 78.0001 70.5C78.0001 64.71 82.7101 60 88.5001 60C94.2901 60 99.0001 64.71 99.0001 70.5C99.0001 76.29 94.2901 81 88.5001 81ZM88.5001 66C86.0176 66 84.0001 68.0175 84.0001 70.5C84.0001 72.9825 86.0176 75 88.5001 75C90.9826 75 93.0001 72.9825 93.0001 70.5C93.0001 68.0175 90.9826 66 88.5001 66Z",
    fill: "currentColor"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M88.5001 96C82.7101 96 78.0001 91.29 78.0001 85.5C78.0001 79.71 82.7101 75 88.5001 75C94.2901 75 99.0001 79.71 99.0001 85.5C99.0001 91.29 94.2901 96 88.5001 96ZM88.5001 81C86.0176 81 84.0001 83.0175 84.0001 85.5C84.0001 87.9825 86.0176 90 88.5001 90C90.9826 90 93.0001 87.9825 93.0001 85.5C93.0001 83.0175 90.9826 81 88.5001 81Z",
    fill: "currentColor"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M31.5001 66C25.7101 66 21.0001 61.29 21.0001 55.5C21.0001 49.71 25.7101 45 31.5001 45C37.2901 45 42.0001 49.71 42.0001 55.5C42.0001 61.29 37.2901 66 31.5001 66ZM31.5001 51C29.0176 51 27.0001 53.0175 27.0001 55.5C27.0001 57.9825 29.0176 60 31.5001 60C33.9826 60 36.0001 57.9825 36.0001 55.5C36.0001 53.0175 33.9826 51 31.5001 51Z",
    fill: "currentColor"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M31.5001 81C25.7101 81 21.0001 76.29 21.0001 70.5C21.0001 64.71 25.7101 60 31.5001 60C37.2901 60 42.0001 64.71 42.0001 70.5C42.0001 76.29 37.2901 81 31.5001 81ZM31.5001 66C29.0176 66 27.0001 68.0175 27.0001 70.5C27.0001 72.9825 29.0176 75 31.5001 75C33.9826 75 36.0001 72.9825 36.0001 70.5C36.0001 68.0175 33.9826 66 31.5001 66Z",
    fill: "currentColor"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M31.5001 96C25.7101 96 21.0001 91.29 21.0001 85.5C21.0001 79.71 25.7101 75 31.5001 75C37.2901 75 42.0001 79.71 42.0001 85.5C42.0001 91.29 37.2901 96 31.5001 96ZM31.5001 81C29.0176 81 27.0001 83.0175 27.0001 85.5C27.0001 87.9825 29.0176 90 31.5001 90C33.9826 90 36.0001 87.9825 36.0001 85.5C36.0001 83.0175 33.9826 81 31.5001 81Z",
    fill: "currentColor"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M75.0001 90H45.0001V96H75.0001V90Z",
    fill: "currentColor"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M57.0001 39H42.0001V45H57.0001V39Z",
    fill: "currentColor"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M72.0001 51H51.0001V57H72.0001V51Z",
    fill: "currentColor"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5176 46.085L10.5276 40.425L46.8951 27.6375L58.4701 22.835L70.1801 13.64L73.8851 18.36L61.5301 28.06L48.9626 33.27L12.5176 46.085Z",
    fill: "currentColor"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M107.483 46.085L70.96 33.2425L58.4701 28.06L46.1151 18.36L49.82 13.64L61.53 22.835L73.1051 27.6375L109.473 40.425L107.483 46.085Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCabin);
export default __webpack_public_path__ + "static/media/Cabin.3e3b3421.svg";
export { ForwardRef as ReactComponent };